function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.6 17.1a10.177 10.177 0 0 0 5.88 2.825.634.634 0 0 0 .819-.561.669.669 0 0 0-.62-.716 9.489 9.489 0 0 1-5.149-2.479c-2.824-2.814-3.385-7.188-1.054-9.527 1.866-1.859 4.965-1.675 7.252-.443l.966-.952c-2.936-1.785-6.831-1.844-9.14.465C3.8 8.479 4.12 13.621 7.6 17.1zM18.815 6.4l.627-.634a.768.768 0 0 0 .03-1.121l-.221-.214a.775.775 0 0 0-1.07.066l-.634.634zm-7.207 7.2 6.662-6.654-1.277-1.27-6.654 6.654-.639 1.549a.256.256 0 0 0 .325.332zm-1.2 1.254c2.353 2.449 6.4 3.364 8.617 1.158 1.8-1.807 1.645-5.017-.317-7.79l-.944.944c1.446 2.132 1.712 4.537.332 5.917-1.7 1.7-4.463.93-6.271-.8z",
  transform: "translate(-4.709 -3.941)"
});

function SvgSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.57,
    height: 16,
    viewBox: "0 0 15.57 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.092d3010.svg";
export { ForwardRef as ReactComponent };